var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "delete") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-431.000000, -418.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "delete",
  transform: "translate(431.000000, 418.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M4,12.6666667 C4,13.4030463 4.59695367,14 5.33333333,14 L10.6666667,14 C11.4030463,14 12,13.4030463 12,12.6666667 L12,4.66666667 L4,4.66666667 L4,12.6666667 M5.33333333,6 L10.6666667,6 L10.6666667,12.6666667 L5.33333333,12.6666667 L5.33333333,6 M10.3333333,2.66666667 L9.66666667,2 L6.33333333,2 L5.66666667,2.66666667 L3.33333333,2.66666667 L3.33333333,4 L12.6666667,4 L12.6666667,2.66666667 L10.3333333,2.66666667 Z",
  id: "Shape",
  fill: "#9E9E9E",
  fillRule: "nonzero"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.182ae0675852cbb42ab7f8bcf45f167d.svg";